<template>
  <v-container fluid>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130">
            <v-icon size="50" color="orange">mdi-checkbook</v-icon>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <v-icon :color="item.locked ? 'red' : 'success'"  small>{{item.locked ? 'mdi-lock' : 'mdi-lock-open'}}</v-icon>
            <h4 class="card-title">{{item.vehicle ? item.vehicle.name + ' ' + item.vehicle.model + ' - ' + item.vehicle.licence_plates : $t('Common.not_assigned')}}</h4>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.TravelWarrants.model.start')}}</label>
                  <p>{{getLocaleDateFormat(item.start, true)}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.TravelWarrants.model.end')}}</label>
                  <p>{{getLocaleDateFormat(item.end, true)}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.TravelWarrants.model.destination')}}</label>
                  <p>{{item.destination}}</p>
                </v-layout>
              </v-flex>
              <v-flex xs12 md3>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.TravelWarrants.model.mission')}}</label>
                  <p>{{item.mission}}</p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-btn color="warning" round class="font-weight-light" :to="'/travel-warrants/' + item.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
            <v-btn round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center class="mt-5">
      <v-flex>
        <users-table 
          hide-subtitle
          icon="mdi-account-group"
          hide-actions
          hide-search
          :sortable="false"
          hide-upload-btn
          :items="item.users"
          travelWarrants
          :appendHeaders="appendHeaders"
        ></users-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import _ from 'lodash';
    import i18n from '@/i18n'
    import UsersTable from '../users/Table'
    export default {
        components: {UsersTable},
        data: () => ({
            item: {users:[], vehicle: {}},
            appendHeaders: [{
              sortable: false,
              text: i18n.t('Pages.TravelWarrants.model.note'),
              value: 'pivot.note',
              align: 'center'
            }]
        }),
        computed: {

        },
        created () {
            this.getTravelWarrant(this.$route.params.id);
        },
        methods: {
            getTravelWarrant(id){
                this.setFetching(true);
                this.repositories.travelWarrant.get(id, {include: 'users.roles'}).then(response => {
                    this.item = response.data.data;
                }).finally(() => {
                    this.setFetching(false);
                });
            },
        }
    }
</script>
